"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitEstimatesIntoHours = void 0;
var moment_1 = __importDefault(require("moment"));
// TODO: delete or change param type
var splitEstimatesIntoHours = function (dailyData) { return dailyData.flatMap(function (estimate) {
    var dailyHoursArray = Array.from({ length: 24 }, function (_, index) { return ({
        from: (0, moment_1.default)(estimate.date).add(index, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        to: (0, moment_1.default)(estimate.date)
            .add(index + 1, 'hours')
            .format('YYYY-MM-DD HH:mm:ss'),
    }); });
    return dailyHoursArray.map(function (hourObject) { return (__assign(__assign(__assign({}, estimate), hourObject), { date: undefined, estimated_budget: estimate.estimated_budget || estimate.estimated_budget === 0
            ? Math.round(estimate.estimated_budget / 24)
            : undefined, labour_limit: estimate.labour_limit || estimate.labour_limit === 0 ? Math.round(estimate.labour_limit) : undefined, actual_budget: estimate.actual_budget || estimate.actual_budget === 0 ? Math.round(estimate.actual_budget / 24) : undefined, target_spmh: estimate.target_spmh || estimate.target_spmh === 0 ? Math.round(estimate.target_spmh) : undefined })); });
}); };
exports.splitEstimatesIntoHours = splitEstimatesIntoHours;
